import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
// import { Link } from "react-router-dom";
// import parse from "html-react-parser";

const Directories = (props) => {
  const { rpdata } = useContext(GlobalDataContext);

  return (
    <div>
      <div className="container">
        <div className="row justify-content-center" style={{ marginTop:"80px"}}>
          {
            rpdata?.gmb?.link && typeof rpdata.gmb.link === "string" && rpdata.gmb.link.trim().length > 0 ?
              <a href={rpdata.gmb.link} target="_blank" rel="noopener noreferrer">
                <img src={rpdata?.gmb?.img} alt="Not found" width={'250px'} />
              </a>
            : (
              <button
                type="button"
                className="btn btn-link"
                style={{ padding: 0, border: "none", background: "none" }}
                aria-disabled="true"
                tabIndex={-1}
              >
                <img src={rpdata?.gmb?.img} alt="Not found" width={'250px'} />
              </button>
            )
          }
        </div>
        <div className="row justify-content-center"></div>
        <h2 className="pd-top-100 text-center">Find Us</h2>
        <div className="row justify-content-center">
          {rpdata?.dbSocialMedia?.directorios.map((item, index) => {
            return (
              <div
                className="col-lg-3 col-md-6 text-center content-directorios"
                key={index}
              >
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <img src={item.image} alt=""></img>
                </a>
              </div>
            );
          })}
          {rpdata?.dbSocialMedia?.redes.map((item, index) => {
            return (
              <div
                className="col-lg-3 col-md-6 text-center content-directorios"
                key={index}
              >
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <img src={item.image} alt=""></img>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Directories;